/* 🤖 this file was generated by svg-to-ts */
export const IconBigMediumSternGefuellt: {
    name: 'big-medium-stern-gefuellt';
    data: string;
} = {
    name: 'big-medium-stern-gefuellt',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M120.45 57.31a6.86 6.86 0 0 0-3.8-11.7l-31.16-4.53a1.86 1.86 0 0 1-1.4-1L70.15 11.82a6.86 6.86 0 0 0-12.3 0L43.91 40.06a1.86 1.86 0 0 1-1.4 1l-31.16 4.55a6.86 6.86 0 0 0-3.8 11.7l22.55 22a1.83 1.83 0 0 1 .53 1.64l-5.32 31a6.86 6.86 0 0 0 10 7.23l27.87-14.65a1.85 1.85 0 0 1 1.74 0l27.82 14.67a6.79 6.79 0 0 0 7.22-.52 6.81 6.81 0 0 0 2.73-6.71l-5.32-31a1.84 1.84 0 0 1 .53-1.65Z"/></svg>`,
};
